export const clientConfigurationStatus = [
    {
        value: 1,
        name: 'Editable',
    },
    {
        value: 2,
        name: 'Under Review',
    },
    {
        value: 3,
        name: 'Confirmed',
    },
    {
        value: 4,
        name: 'Hidden',
    },
];

export const configurationMapper = id => {
    return clientConfigurationStatus.find(cs => cs.value === id) || null;
};
